/* @flow */
// TODO possible add this to @homeaway/react-image-carousel

import {trigger as edapTrigger, GENERIC_EVENT} from './edapWrapper';

export const PHOTOCAROUSEL_ADVANCE = 'photo carousel advance';
export const MAP_PHOTOCAROUSEL_ADVANCE = 'map photo carousel advance';
export const PHOTOCAROUSEL_IMAGE_POSITION = 'photo carousel image position';
export const PHOTOCAROUSEL_LEFT_LABEL = 'left';
export const PHOTOCAROUSEL_RIGHT_LABEL = 'right';
export type CarouselEdapEventAction =
    | typeof PHOTOCAROUSEL_ADVANCE
    | typeof MAP_PHOTOCAROUSEL_ADVANCE
    | typeof PHOTOCAROUSEL_IMAGE_POSITION;

export const triggerCarouselEDAPEvent = (
    action: CarouselEdapEventAction,
    label: string
) => {
    edapTrigger(GENERIC_EVENT, {
        eventaction: action,
        highfrequency: 'true',
        eventlabel: label
    });
};

export const triggerCarouselImagePositionEdapEvent = (label: string) => {
    triggerCarouselEDAPEvent(PHOTOCAROUSEL_IMAGE_POSITION, label);
};
